// Files dropped directly into the chat are saved to a dedicated library folder
// (always persisted, never ephemeral — the agent needs them indexed). Both the
// client (ChatPanel upload) and any server-side reference agree on this path.
// CHAT_UPLOADS_PATH must equal slugify(CHAT_UPLOADS_FOLDER_NAME) prefixed with '/'.
export const CHAT_UPLOADS_FOLDER_NAME = 'Chat uploads'
export const CHAT_UPLOADS_PATH = '/chat-uploads'
